import React, { memo, useEffect, useState } from 'react';
import { fetchReportFieldDropDownOptionsWithCaches } from '../../../api';
import { ReportField, ReportFieldType } from '../../../models';
import * as Styled from './styled';
import { useAuth } from '../../../context';
import { defaultDateFormat, formatDateByLocale, parseDateWithValidation } from '../../../util/dateHelpers';

interface ReportMustHaveFilterValueProps {
  reportField: ReportField;
  fieldValue: string;
  clientId: number;
  standardReportId?: number;
}

function ReportMustHaveFilterValue({
  reportField,
  fieldValue,
  clientId,
  standardReportId,
}: ReportMustHaveFilterValueProps): JSX.Element {
  const { user } = useAuth();
  const [displayedValues, setDisplayedValues] = useState<string[]>([
    fieldValue,
  ]);
  useEffect(() => {
    if (reportField.fieldType !== ReportFieldType.DropDown) {
      return;
    }
    const fetchData = async (): Promise<void> => {
      const dropdownOptions = await fetchReportFieldDropDownOptionsWithCaches(
        reportField.id,
        clientId,
        reportField.isClientCustom,
        reportField.isAllocation,
        reportField.isDimension,
        reportField.isDimensionItemId,
        standardReportId,
      );
      const selectedIds = new Set(fieldValue.split(';'));
      const selectedLabels = dropdownOptions.reduce((acc, opt) => {
        if (!selectedIds.has(`${opt.value}`)) return acc;
        acc.push(opt.label);
        return acc;
      }, []);
      setDisplayedValues(selectedLabels);
    };
    fetchData();
  }, [
    clientId,
    fieldValue,
    reportField.id,
    reportField.fieldType,
    standardReportId,
    reportField.isClientCustom,
    reportField.isAllocation,
    reportField.isDimension,
    reportField.isDimensionItemId,
  ]);

  return (
    <Styled.ReportMustHaveFilterValueText>
      {displayedValues.map((val) => {
        let formatted = val;
        const parsedDate = parseDateWithValidation(val, defaultDateFormat);
        if (parsedDate) {
          formatted = formatDateByLocale(parsedDate, user.localePreference);
        }
        return <div key={val}>{formatted}</div>;
      })}
    </Styled.ReportMustHaveFilterValueText>
  );
}

export default memo(ReportMustHaveFilterValue);
